import { ProjectTemplateEnum } from '~/shared/api'
import { ProjectModuleSlugEnum } from '~/shared/const'

const GRAPHQL_NATIVE_MODULE_SLUG: Record<string, string> = {
  ABOUT_PROJECT: ProjectModuleSlugEnum.AboutProject,
  PROJECT_MEMBERS: ProjectModuleSlugEnum.ProjectMembers,
  PROJECT_MANAGEMENT: ProjectModuleSlugEnum.ProjectManagement,
  SUPPORTERS: ProjectModuleSlugEnum.Supporters,
  PROJECT_NEWS: ProjectModuleSlugEnum.ProjectNews,
  PROJECT_SURVEY: ProjectModuleSlugEnum.ProjectSurvey,
  PROJECT_ORG_MAIL: ProjectModuleSlugEnum.ProjectOrgMail,
  PROJECT_SPEECHES: ProjectModuleSlugEnum.ProjectSpeeches,
  QUESTION_TO_DEPUTY: 'question_to_deputy',
  SERVICE_PHONES: 'service_phones',
  PROJECT_COUNTERS: 'project_counters',
  CONSUMER_RIGHTS: 'consumer_rights',
  ACCIDENT_GUIDANCE: 'accident_guidance',
  ENTERTAINMENT: 'entertainment',
  PROJECT_CALENDAR: 'project_calendar',
}

export function normalizeWorkspaceModuleSlug(slug: string): string {
  return GRAPHQL_NATIVE_MODULE_SLUG[slug] ?? slug
}

export function isModuleEnabledOnWorkspace(
  enabledSlugs: string[] | undefined | null,
  moduleSlug: string,
): boolean {
  if (!enabledSlugs?.length) {
    return false
  }
  const normalizedTarget = normalizeWorkspaceModuleSlug(moduleSlug)
  return enabledSlugs.some(
    s => normalizeWorkspaceModuleSlug(s) === normalizedTarget,
  )
}

export function isModuleVisibleOnWorkspace(
  _enabledSlugs: string[] | undefined | null,
  visibleSlugs: Set<string>,
  moduleSlug: string,
): boolean {
  const normalizedTarget = normalizeWorkspaceModuleSlug(moduleSlug)
  for (const visible of visibleSlugs) {
    if (normalizeWorkspaceModuleSlug(visible) === normalizedTarget) {
      return true
    }
  }
  return false
}

const WORKSPACE_NATIVE_GRID_SLUGS_EXCLUDED_ALWAYS = new Set<string>([
  normalizeWorkspaceModuleSlug(ProjectModuleSlugEnum.ProjectSpeeches),
])

export function isSlugListedOnWorkspaceNativeGrid(
  moduleSlug: string,
  templateType: ProjectTemplateEnum | undefined,
): boolean {
  const normalizedTarget = normalizeWorkspaceModuleSlug(moduleSlug)
  if (WORKSPACE_NATIVE_GRID_SLUGS_EXCLUDED_ALWAYS.has(normalizedTarget)) {
    return false
  }
  if (
    normalizedTarget
    === normalizeWorkspaceModuleSlug(ProjectModuleSlugEnum.ProjectSurvey)
  ) {
    return (
      templateType === ProjectTemplateEnum.Deputy
      || templateType === ProjectTemplateEnum.ExpertOpinion
    )
  }
  return true
}
